import { render, staticRenderFns } from "./vipEquity.vue?vue&type=template&id=6089948c&scoped=true"
import script from "./vipEquity.vue?vue&type=script&lang=js"
export * from "./vipEquity.vue?vue&type=script&lang=js"
import style0 from "./vipEquity.vue?vue&type=style&index=0&id=6089948c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6089948c",
  null
  
)

export default component.exports